<template>
    <div id="v-factory-wrap">
        <!-- 顶部栏 -->
        <div class="head">
            <dl>
                <dt>
                    <img class="logo" :src="$config.resource + 'dhl_logo.png'" alt="">
                </dt>
                <!-- 头像信息 -->
                <dd>
                    <div class="portrait">
                        <img class="pic" :src="user.head" alt="">
                    </div>
                    <p>{{user.company_name}}</p>
                    <div class="quit" @click="onQuit">
                        <img class="icon" :src="$config.resource + 'tc.png'" alt="">
                    </div>
                </dd>
            </dl>
        </div>
        <!-- 主要部分 -->
        <div class="main_box">
            <!-- 步骤 -->
            <div class="step">
                <img class="pic_bg" :src="$config.resource + 'db_bjt.png'" alt="">
                <div class="row_box">
                    <div class="row curr">
                        <div class="circle">1</div>
                        <p>选择供应商类型</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row curr">
                        <div class="circle">2</div>
                        <p>企业概况</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row curr">
                        <div class="circle">3</div>
                        <p>工厂概况</p>
                    </div>
                    <div class="wire"></div>
                    <div class="row">
                        <div class="circle">4</div>
                        <p>产品概况</p>
                    </div>
                    <div class="wire"></div>
                    <div class="row">
                        <div class="circle">5</div>
                        <p>提交</p>
                    </div>
                </div>
            </div>
            <!-- 人员概况 -->
            <div class="alike alike_one">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>基础信息</p>
                </div>
                <ul>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">人员总数：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="total" />
                            <div class="unit">人</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">管理人员：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="manage" />
                            <div class="unit">人</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">生产人员：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="production" />
                            <div class="unit">人</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">研发人员：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="research_staff" />
                            <div class="unit">人</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">质量人员：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="quality" />
                            <div class="unit">人</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">销售人数：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="sell" />
                            <div class="unit">人</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">售后人员：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="after_sale" />
                            <div class="unit">人</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">其他/她人员：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="rests" />
                            <div class="unit">人</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">是否支持国外售后：</div>
                        </div>
                        <el-select class="elect" v-model="service" @change="getService">
                            <el-option
                            v-for="item in leaseback"
                            :key="item.name"
                            :label="item.name"
                            :value="item">
                            </el-option>
                        </el-select>
                    </li>
                </ul>
            </div>
            <!-- 研发设计能力 -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>研发设计能力</p>
                </div>
                <ul>
                    <li>
                        <div class="name">
                            <div class="tt design">每年研发投入金额：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="money" />
                            <div class="unit">万元</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">设计领域：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="field" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <div class="tt design">设计软件名称：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="software" />
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 工厂状况 -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>工厂状况</p>
                    <div class="remark">备注：有则输入面积，无工厂则输入0</div>
                </div>
                <ul>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">工厂占地面积：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="floor_area" />
                            <div class="unit">m²</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">工厂建筑面积：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="covered_area" />
                            <div class="unit">m²</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">仓库面积：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="storage_area" />
                            <div class="unit">m²</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">工厂生产面积：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="production_area" />
                            <div class="unit">m²</div>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 按钮 -->
            <div class="btn_box">
                <div class="btn gray" v-if="isType!=2" @click="onSave">保存草稿</div>
                <div class="btn gray" @click="onBack">上一步</div>
                <div class="btn red" v-if="isType!=2" @click="onSubmit">下一步</div>
                <div class="btn red" v-if="isType==2" @click="toViewPage('/product',{type:2})">下一步</div>
            </div>
        </div>
    </div>
</template>
<script>
    import store from '../vuex/store.js';
    export default {
        data(){
            return{
                user:'',// 用户信息
                isType:'',// 1.提交下一步 2.详情下一步3.重新提交

                total:'',// 人员总数
                manage:'',// 管理人员
                production:'',// 生产人员
                research_staff :'',// 研发人员
                quality:'',// 质量人员
                sell:'',// 销售人数
                after_sale:'',// 售后人员
                rests:'',// 其它人员
                service:'',// 是否支持国外售后
                leaseback:[// 是否支持国外售后
                    {
                        id:1,
                        name:'是，售后响应时间24H',
                    },
                    {
                        id:2,
                        name:'是，售后响应时间48H',
                    },
                    {
                        id:0,
                        name:'否',
                    },
                ],
                serviceId:'',// 是否支持国外售后
                money:'',// 每年研发投入金额
                field:'',// 设计领域
                software:'',// 设计软件名称
                floor_area:'',// 工厂占地面积
                covered_area:'',// 工厂建筑面积
                storage_area:'',// 仓库面积
                production_area:'',// 工厂生产面积
            }
        },
        store,
        methods: {
            //页面跳转
            toViewPage($path,$query) {
                this.$jump.toViewPage(this,$path,$query)
            },
            // 保存草稿
            onSave(){
                const that = this
                // let foreign_af ='';// 是否支持国外售后
                // if(that.serviceId==3){
                //     foreign_af = 0
                // }else{
                //     foreign_af = that.serviceId
                // }
                that.$request({
                    that: that,
                    api: that.$api.editFactory,
                    data: {
                        total:that.total,// 人员总数
                        management:that.manage,// 管理人员
                        production:that.production,// 生产人员
                        rd:that.research_staff,// 研发人员
                        quality:that.quality,// 质量人员
                        sales:that.sell,// 销售人数
                        after_sales:that.after_sale,// 售后人员
                        other:that.rests,// 其它人员
                        foreign_af:that.serviceId,// 是否支持国外售后
                        rd_money:that.money,// 每年研发投入金额
                        design:that.field,// 设计领域
                        software:that.software,// 设计软件名称
                        area:that.floor_area,// 工厂占地面积
                        buil_area:that.covered_area,// 工厂建筑面积
                        warehouse:that.storage_area,// 仓库面积
                        production_area:that.production_area,// 工厂生产面积
                        type:2,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: res.msg,
                            timeout: 1500,
                            icon: 'success',
                        })
                    }
                })
            },
            // 上一步
            onBack(){
                this.$router.go(-1);
            },
            // 提交下一步
            onSubmit(){
                const that = this
                // let foreign_af ='';// 是否支持国外售后
                // if(that.serviceId==3){
                //     foreign_af = 0
                // }else{
                //     foreign_af = that.serviceId
                // }
                that.$request({
                    that: that,
                    api: that.$api.editFactory,
                    data: {
                        total:that.total,// 人员总数
                        management:that.manage,// 管理人员
                        production:that.production,// 生产人员
                        rd:that.research_staff,// 研发人员
                        quality:that.quality,// 质量人员
                        sales:that.sell,// 销售人数
                        after_sales:that.after_sale,// 售后人员
                        other:that.rests,// 其它人员
                        foreign_af:that.serviceId,// 是否支持国外售后
                        rd_money:that.money,// 每年研发投入金额
                        design:that.field,// 设计领域
                        software:that.software,// 设计软件名称
                        area:that.floor_area,// 工厂占地面积
                        buil_area:that.covered_area,// 工厂建筑面积
                        warehouse:that.storage_area,// 仓库面积
                        production_area:that.production_area,// 工厂生产面积
                        type:1,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: '提交成功',
                            timeout: 1500,
                            icon: 'success',
                            callback(){
                                that.$router.push({ path: '/product',query:{type:that.isType} })
                            }
                        })
                    }
                })
            },
            // 是否支持国外售后
            getService(value){
                console.log('打印',value)
                this.serviceId = value.id
                this.service = value.name
            },
            // 获取保存草稿
            getDraft(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.firstTrialDraft,
                    data: {},
                    success(res) {
                        that.total = res.data.total // 人员总数
                        that.manage = res.data.management // 管理人员
                        that.production = res.data.production // 生产人员
                        that.research_staff = res.data.rd // 研发人员
                        that.quality = res.data.quality // 质量人员
                        that.sell = res.data.sales // 销售人数
                        that.after_sale = res.data.after_sales // 售后人员
                        that.rests = res.data.other // 其它人员
                        if(res.data.foreign_af!=null&&res.data.foreign_af!=''){// 是否支持国外售后
                            console.log('查看2',res.data.foreign_af)
                            if(res.data.foreign_af==0){
                                that.serviceId = res.data.foreign_af
                                that.service = '否'
                            }
                            if(res.data.foreign_af==1){
                                that.serviceId = res.data.foreign_af
                                that.service = '是，售后响应时间24H'
                            }
                            if(res.data.foreign_af==2){
                                that.serviceId = res.data.foreign_af
                                that.service = '是，售后响应时间48H'
                            }
                        }
                        
                        that.money = res.data.rd_money // 每年研发投入金额
                        that.field = res.data.design // 设计领域
                        that.software = res.data.software // 设计软件名称
                        that.floor_area = res.data.area // 工厂占地面积
                        that.covered_area = res.data.buil_area // 工厂建筑面积
                        that.storage_area = res.data.warehouse // 仓库面积
                        that.production_area = res.data.production_area // 工厂生产面积
                    }
                })
            },
            // 获取审批后详情
            getDetails(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.particulars,
                    data: {},
                    success(res) {
                        that.total = res.data.total // 人员总数
                        that.manage = res.data.management // 管理人员
                        that.production = res.data.production // 生产人员
                        that.research_staff = res.data.rd // 研发人员
                        that.quality = res.data.quality // 质量人员
                        that.sell = res.data.sales // 销售人数
                        that.after_sale = res.data.after_sales // 售后人员
                        that.rests = res.data.other // 其它人员
                        if(res.data.foreign_af!=null&&res.data.foreign_af!=''){// 是否支持国外售后
                            if(res.data.foreign_af==0){
                                that.serviceId = res.data.foreign_af
                                that.service = '否'
                            }
                            if(res.data.foreign_af==1){
                                that.serviceId = res.data.foreign_af
                                that.service = '是，售后响应时间24H'
                            }
                            if(res.data.foreign_af==2){
                                that.serviceId = res.data.foreign_af
                                that.service = '是，售后响应时间48H'
                            }
                        }
                        that.money = res.data.rd_money // 每年研发投入金额
                        that.field = res.data.design // 设计领域
                        that.software = res.data.software // 设计软件名称
                        that.floor_area = res.data.area // 工厂占地面积
                        that.covered_area = res.data.buil_area // 工厂建筑面积
                        that.storage_area = res.data.warehouse // 仓库面积
                        that.production_area = res.data.production_area // 工厂生产面积
                    }
                })
            },
            // 用户信息
            getUser(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.consumer,
                    data: {},
                    success(res) {
                       that.user = res.data
                    }
                })
            },
            // 退出
            onQuit(){
                const that = this
                //存储用户登录凭证
                that.$storage.remove('accesstoken')

                //登录成功发起页面跳转
                that.$dialog.toast({
                    mes: '退出登录成功',
                    timeout: 2000,
                    icon: 'success',
                    callback(){
                        that.$router.push({ path: '/logIn' })
                    }
                })
            },
        },
        mounted() {
            const that = this
            that.$store.commit('EditPageData',this.PageData)
            that.getUser()// 用户信息
            that.isType = that.$route.query.type
            if(that.$route.query.type==2){
                that.getDetails()// 获取审批后详情
            }else{
                that.getDraft()// 获取保存草稿
            }
        },
        created() {
        },
        components:{
            
        },
    }
</script>


// WEBPACK FOOTER //
// src/page/factory.vue